import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";
import { useReveal } from "@/hooks/useReveal";

function formatDate(iso) {
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("en-GB", { day: "2-digit", month: "long", year: "numeric" });
  } catch {
    return "";
  }
}

export default function LatestInsights() {
  const [items, setItems] = useState([]);
  const ref = useReveal();
  useEffect(() => {
    api.get("/insights?limit=4").then((r) => setItems(r.data.slice(0, 4))).catch(() => setItems([]));
  }, []);
  return (
    <section className="py-28 md:py-40 reveal" ref={ref} data-testid="latest-insights">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14 md:mb-20">
          <div>
            <h2 className="h-display text-[clamp(2.2rem,5vw,4.4rem)]">
              Considered writing<br />on the matters at hand.
            </h2>
          </div>
          <Link to="/insights" className="link-grow text-sm font-medium tracking-[0.16em] uppercase" data-testid="insights-view-all">
            All insights <ArrowUpRight size={16} className="arrow" />
          </Link>
        </div>

        <div className="hairline-top">
          {items.map((it) => (
            <Link
              key={it.slug}
              to={`/insights/${it.slug}`}
              className="num-list-row hairline-bottom grid grid-cols-12 gap-4 md:gap-8 py-8 md:py-10 items-baseline"
              data-testid={`insight-row-${it.slug}`}
            >
              <div className="col-span-12 md:col-span-3 text-xs text-graphite/55">
                {formatDate(it.published_at || it.created_at)} · {it.category}
              </div>
              <div className="col-span-12 md:col-span-7">
                <h3 className="num-title text-2xl md:text-3xl font-semibold tracking-tight max-w-3xl">{it.title}</h3>
                {it.subtitle && <p className="mt-3 text-graphite/75 leading-relaxed max-w-3xl">{it.subtitle}</p>}
              </div>
              <div className="hidden md:flex md:col-span-2 justify-end num-arrow">
                <ArrowUpRight size={26} className="text-[#1E3668]" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
